import { render, staticRenderFns } from "./ComplaintDetailAnswer.vue?vue&type=template&id=b0ccf7be"
import script from "./ComplaintDetailAnswer.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports